import type { AccountMembership } from '../types/account-access.type';
import { PROPERTIES } from './group-scope.seed';

/**
 * The signed-in user's account roles. The rotation deliberately mixes the four
 * account system roles and leaves gaps (`null`): belonging to an organisation
 * does not mean belonging to every account under it, and holding a role does
 * not mean that role can open account settings — the accounts listing has to be
 * able to show both cases.
 */
const ROLE_ROTATION: ReadonlyArray<string | null> = [
  'acc-owner',
  'acc-administrator',
  'acc-standard',
  'acc-readonly',
  null,
  'acc-administrator',
  'acc-standard',
];

export const ACCOUNT_MEMBERSHIPS_SEED: ReadonlyArray<AccountMembership> = PROPERTIES.flatMap(
  (account, index) => {
    const roleTemplateId = ROLE_ROTATION[index % ROLE_ROTATION.length];
    return roleTemplateId ? [{ accountId: account.id, roleTemplateId }] : [];
  },
);
